<ac-card>
  <ac-card-content>
    <div class="redemption-dialog">
      @switch (redemption().redemption_status) { @case('complete') {
      <app-redemption-dialog-header
        [step]="3"
        title="Redemption Complete"
        subtitle="Your transaction has been successfully confirmed on the blockchain and your funds have been added to your wallet."
        [hideBack]="true"
        [hideBalance]="true"
        (close)="close.emit(null)"
      />
      } @case('failed') {
      <app-redemption-dialog-header
        [step]="3"
        title="Redemption Failed"
        subtitle="There was an issue processing your redemption and your funds have been credited back to your account."
        [hideBack]="true"
        [hideBalance]="true"
        (close)="close.emit(null)"
      />
      } @case('blocked') {
      <app-redemption-dialog-header
        [step]="3"
        [stepColor]="'blocked'"
        title="Redemption Under Review"
        [subtitle]="blockedSubtitle()"
        [hideBack]="true"
        [hideBalance]="true"
        (close)="close.emit(null)"
      />
      } @case('aborted') {
      <app-redemption-dialog-header
        [step]="3"
        [stepColor]="'failed'"
        title="Redemption Canceled"
        subtitle="Your redemption has been canceled and your SC has been returned to your balance."
        [hideBack]="true"
        [hideBalance]="true"
        (close)="close.emit(null)"
      />
      } @default {
      <app-redemption-dialog-header
        [step]="2"
        title="Redemption in Progress"
        subtitle="Your transaction is in progress and pending confirmation from the blockchain. You will receive a notification when the redemption is complete."
        [hideBack]="true"
        [hideBalance]="true"
        (close)="close.emit(null)"
      />
      } }
      <div class="ac-flex ac-ctr">
        @switch (redemption().redemption_status) { @case('complete') {
        <app-lottie-animation
          [size]="132"
          path="payments_complete"
          [loop]="false"
        />
        } @case('failed') {
        <ac-icon iconKey="payment:fail" [size]="132" />
        } @case('blocked') {
        <app-lottie-animation
          [size]="132"
          path="payments_blocked"
          [loop]="false"
        />
        } @case('aborted') {
        <ac-icon iconKey="payment:fail" [size]="132" />
        } @default {
        <app-lottie-animation [size]="132" path="payments_pending" />
        } }
      </div>
      <ul class="redemption-dialog__crypto-confirm-table ac-body-md">
        @if (redemption().redemption_status !== 'blocked' && redemption().redemption_status !== 'aborted') {
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">Asset</div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div
              class="ac-flex-ctr redemption-dialog__crypto-confirm-table-icon"
            >
              <ac-icon [iconKey]="currentCurrency().ui_icon" [size]="16" />
            </div>
            <div>
              {{ currentCurrency().ui_label ?? currentCurrency().ui_name }}
              <span class="ac-label">{{ currentCurrency().ticker }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">
            Receiving Address
          </div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            {{ redemption().payment_method_entity_id }}
          </div>
        </li>
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">Amount</div>
          @if (redemption().amount |
          currencyConvert:redemption().currency_id:'USD' | async |
          currency:'USD':'symbol-narrow'; as convertedAmount) {
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>
              {{
                redemption().amount | decimal : currentCurrency().ui_decimals
              }}
              {{ currentCurrency().ticker }}
            </div>
            <div class="ac-label">({{ convertedAmount }})</div>
          </div>
          } @else {
          <div class="ac-flex ac-ctr">
            <mat-spinner [diameter]="16" />
          </div>
          }
        </li>
        @if (redemption().transaction_fee_amount! |
        currencyConvert:redemption().currency_id:'USD' | async |
        currency:'USD':'symbol-narrow'; as convertedAmount) {
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">Fee</div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>
              {{
                redemption().transaction_fee_amount
                  | decimal : currentCurrency().ui_decimals
              }}
              {{ currentCurrency().ticker }}
            </div>
            <div class="ac-label">({{ convertedAmount }})</div>
          </div>
        </li>
        }
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">
            Total Redemption
          </div>
          @if (totalRedemptionAmount() |
          currencyConvert:redemption().currency_id:'USD' | async |
          currency:'USD':'symbol-narrow'; as convertedAmount) {
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>
              {{
                totalRedemptionAmount()
                  | decimal : currentCurrency().ui_decimals
              }}
              {{ currentCurrency().ticker }}
            </div>
            <div class="ac-label">({{ convertedAmount }})</div>
          </div>
          } @else {
          <div class="ac-flex ac-ctr">
            <mat-spinner [diameter]="16" />
          </div>
          }
        </li>
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">
            Time & Date
          </div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>
              {{ redemption().created_at | date : 'MMMM d, yyyy • h:mm a' }}
            </div>
          </div>
        </li>
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">Status</div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div
              class="redemption-dialog__pill redemption-dialog__pill--{{
                redemption().redemption_status
              }}"
            >
              {{ redemption().confirmations ?? 0 }} Confirmation{{
                redemption().confirmations !== 1 ? 's' : ''
              }}
            </div>
          </div>
        </li>
        @if (redemption().blockchain_id && redemption().transaction_hash) {
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">
            Blockchain Link
          </div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            <a
              target="_blank"
              [href]="
                redemption().transaction_hash!
                  | blockchainUrl : redemption().blockchain_id! : 'tx'
              "
              class="redemption-dialog__link ac-title-md"
            >
              View in Explorer
              <ac-icon iconKey="payment:external_link" [size]="16" />
            </a>
          </div>
        </li>
        } } @else {
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">Amount</div>
          @if (redemption().amount |
          currencyConvert:redemption().currency_id:'USD' | async |
          currency:'USD':'symbol-narrow'; as convertedAmount) {
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>
              {{
                redemption().amount | decimal : currentCurrency().ui_decimals
              }}
              {{ currentCurrency().ticker }}
            </div>
            <div class="ac-label">({{ convertedAmount }})</div>
          </div>
          } @else {
          <div class="ac-flex ac-ctr">
            <mat-spinner [diameter]="16" />
          </div>
          }
        </li>
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">Status</div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div
              class="redemption-dialog__pill redemption-dialog__pill--{{
                redemption().redemption_status
              }}"
            >
              @if (redemption().redemption_status === 'aborted') {
              Canceled
              } @else { Under Review }
            </div>
          </div>
        </li>
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">
            Time & Date
          </div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>
              {{ redemption().created_at | date : 'MMMM d, yyyy • h:mm a' }}
            </div>
          </div>
        </li>
        }
      </ul>
      @if (redemption().redemption_status === 'blocked') {
      <div class="redemption-dialog__footer">
        @if (redemption().blocked_due_to_payment_method_verification) {
        <div class="redemption-dialog__footer-text ac-body-sm">
          We need to verify the card used for your purchase before this redemption can be released.
        </div>
        } @else {
        <div class="redemption-dialog__footer-text ac-body-sm">
          Contacting support will not speed up the review or processing time. You'll receive an email as soon as your redemption is approved and completed.
        </div>
        }
      </div>
      @if (redemption().blocked_due_to_payment_method_verification) {
      <button
        (click)="close.emit('additional-verification'); $event.preventDefault()"
        class="ac-btn-lg"
        mat-flat-button
      >
        Complete verification to continue
      </button>
      }
      <button
        (click)="cancelRedemption(); $event.preventDefault()"
        class="ac-btn-lg ac-danger"
        [loading]="cancelInProgress()"
        mat-flat-button
      >
        Cancel Redemption
      </button>
      }
    </div>
  </ac-card-content>
</ac-card>
